import IndexLinks from "../IndexLinks"

const HelpTopicVersementIndex = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Versements', link: '/topics/versements'},
  ]

  const links = [
    { title: "Fonctionnement des versements", link: '/topics/versements/fonctionnment-versements'},
  ]

  return <IndexLinks goBackLinks={goBackLinks} links={links}/>
}

export default HelpTopicVersementIndex